import 'rxjs/add/operator/debounceTime';
import { columns } from './daily-log-component.config';
import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import {
  DailyLogOperationInstance,
  DailyLogType,
  DailyOperationLogRecord
} from '../../../models/projects/operation.models';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { SetupService } from '../../../services/setup/setup.service';
import { OperationService } from '../../../services/operations/operation/operation.service';
import { State } from '@progress/kendo-data-query';
import { SetupChangeType, UpdatedSetupSummary } from '../../../models/setup/setup.models';
import { DailyLogService } from '../../../services/daily-log/daily-log.service';
import { DateService } from '../../../services/date/date.service';
import { DateParserService } from '../../../services/daily-log/daily-log-time/date-parser-service';
import { OperationDetailsEditPage } from '../../operations/operation-details-edit/operation-details-edit';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { RecordOperationLinkService } from '../../../services/record-operation-link/record-operation-link.service';
import { CommentEditPage } from '../../comments/comment-edit/comment-edit';
import { DailyLogTimeService } from '../../../services/daily-log/daily-log-time/daily-log-time-service';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import {
  ErrorType,
  PageValidationType,
  ValidationError,
  ValidationResult
} from '../../../models/projects/validation.models';
import {
  DailyLogValidationService
} from '../../../services/daily-log/daily-log-validation/daily-log-validation.service';
import {
  DailyProgressReportPreviewPage
} from '../../daily-progress-report/daily-progress-report-preview/daily-progress-report-preview';
// tslint:disable-next-line:max-line-length
import {
  ContractualOperationValidatorService
} from '../../../services/operations/operation-validation/contractual-operation-validator-service/contractual-operation-validator.service';
import { ErrorsPage } from '../../shared/components/errors-page/errors-page';
import { LockedDayService } from '../../../services/locked-day/locked-day.service';
import { LockDayFilters } from '../../../models/lock-day.models';
import { AppDataSyncService } from '../../../services/app-data-sync/app-data-sync.service';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import { AppData, AppDataSummary } from '../../../models/app-data/app-data';
import { Subject } from 'rxjs/Subject';
import { timer } from 'rxjs/observable/timer';
import { catchError, debounce } from 'rxjs/operators';
import { CompleteDayFilters } from '../../../models/complete-day.models';
import { CompleteDayService } from '../../../services/complete-day/complete-day.service';
import { LocalSaveService } from '../../../services/local/local-save.service';
import { TransitingSaveService } from '../../../services/operations/transiting-save/transiting-save.service';
import { DailyProgressReportService } from '../../../services/daily-progress-report/daily-progress-report.service';
import { DailyProgressReportContext } from '../../../models/daily-progress-report/daily-progress-report.models';
import { DailyLogEntriesService } from '../../../services/daily-log/daily-log-entries/daily-log-entries.service';
import { VesselService } from '../../../services/vessel/vessel.service';
import { TimeZoneService } from '../../../services/time-zone/time-zone.service';
import { TimeZoneChangeEditor, TimeZoneFilters } from '../../../models/time-zones/time-zone.models';
import { ValidationService } from '../../../services/validation/validation.service';
import { cloneDeep } from 'lodash';
import { DailyLogPermissions, LockedDayPermissions } from '../../../models/permissions/permission.models';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { WarningModalComponent } from '../../shared/components/warning-modal/warning-modal.component';
import { LocalOperationSaveService } from '../../../services/local/operation/local-operation-save.service';
import { ImplementerInitialiserPage } from '../../implementer/implementer-initialiser/implementer-initialiser';
import { ImplementerService } from '../../../services/implementer/implementer.service';
import { ImplementerSnapshotSummary } from '../../../models/implementer/implementer.models';
import { AppConfig } from '../../../app/app.config';
import { DateTime } from 'luxon';
import { ChangeHistoryPage } from '../../change-history/change-history/change-history';
import {
  SignatureDateModalComponent
} from '../../daily-progress-report/signature-date-modal/signature-date-modal.component';
import { SignaturesPayload } from '../../../models/dpr-signatures/dpr-signatures.models';
import {
  DailyLogConcurrentEditCoordinator,
  DailyLogConcurrentEditHost
} from '../../../services/daily-log/daily-log-concurrent-edit-coordinator.service';
import { SupportContextKey } from '../../../models/support/support.models';
import { SupportContextService } from '../../../services/support/support-context.service';
import { CyclesService } from '../../../services/cycles/cycles.service';

@Component({
  selector: 'app-daily-log-component',
  templateUrl: './daily-log-component.component.html',
  providers: [DailyLogConcurrentEditCoordinator]
})

export class DailyLogComponent implements OnDestroy, DailyLogConcurrentEditHost {
  @ViewChild('dailyLogGrid') grid?: GridComponent;

  @Input() isModal: boolean = false;
  @Input() isReadonly: boolean = false;
  @Input() inputDate: DateTime;

  config = AppConfig.settings;
  dailyLogDate: PtLuxonDate = new PtLuxonDate();
  dailyLogDisplayDate: string;
  public mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];

  timeZones: TimeZoneChangeEditor[];
  currentDate: PtLuxonDate;

  canGoForward: boolean = false;
  maxDate: DateTime = DateTime.local(); // used for the daily log datepicker
  activeLogDate: DateTime;
  activeDayNavigationLoading = false;

  validationLoading: boolean;
  summaryLoading: boolean;
  saving: boolean;
  dailyLogRequiresReload: boolean;
  dateLoading: boolean = true;
  setupSummary: UpdatedSetupSummary;
  dateChangeLoading: boolean;
  changingLogDate = false;
  retainLogDuringDateChange = false;
  dateChangeError: string;
  recordSaveLoading: boolean = false;
  pageLoading = true; // used to stop the Complete Day from being enabled when loading the page (was previously tied to grid.loading)
  editDayLoading: boolean = false;
  canEditRecentDay: boolean = false;
  dayWorkflowError: string;
  signOffDayLoading: boolean;

  gridData: GridDataResult;
  columns = columns;
  state: State;

  initialLoadComplete: boolean;
  gridLoading: boolean;
  setupComplete: boolean;
  dayLockedByDate: boolean = false; // means that the day is locked by the current date, so can therefore be edited
  isImplementerActiveForDay: boolean; // when true the day will be open for editing regardless of dayLockedByDate
  activeImplementerPreventingDayCompletion: boolean; // on vessel env, if implementer is active for any day at all, then they can't complete current
  activeSnapshotSummary: ImplementerSnapshotSummary;
  lockable: boolean = false;

  dayCompleted: boolean;
  daySignedOff: boolean;

  dailyLogData: DailyOperationLogRecord[];

  validationResult: ValidationResult = new ValidationResult();
  currentValidationLoadingValue: number;

  sidebarCollapsed: boolean;
  loaded: boolean = false;

  dataToUpdate: AppData = new AppData();
  $confirmedChange: Subject<AppData> = new Subject<AppData>();

  debounceActive = false;

  currentLogDate: DateTime = DateTime.local();

  permissions: DailyLogPermissions = new DailyLogPermissions();
  lockedDayPermissions: LockedDayPermissions = new LockedDayPermissions();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public setupService: SetupService,
    public operationService: OperationService,
    public dateService: DateService,
    public dateParserService: DateParserService,
    public dailyLogService: DailyLogService,
    public dailyLogTimeService: DailyLogTimeService,
    public recordOperationLinkService: RecordOperationLinkService,
    public modalController: ModalController,
    public dailyLogValidatorService: DailyLogValidationService,
    public contractualOperationValidatorService: ContractualOperationValidatorService,
    private appDataSyncService: AppDataSyncService,
    private navHelperService: NavHelperService,
    public completeDayService: CompleteDayService,
    private localSaveService: LocalSaveService,
    private transitingSaveService: TransitingSaveService,
    private dprService: DailyProgressReportService,
    private dailyLogEntriesService: DailyLogEntriesService,
    private vesselService: VesselService,
    private timeZoneService: TimeZoneService,
    private appDataService: AppDataSyncService,
    private validationService: ValidationService,
    private permissionService: PermissionsService,
    private dailyProgressReportService: DailyProgressReportService,
    private localOperationSaveService: LocalOperationSaveService,
    private implementerService: ImplementerService,
    private lockedDayService: LockedDayService,
    private supportContextService: SupportContextService,
    private cyclesService: CyclesService,
    public concurrentChanges: DailyLogConcurrentEditCoordinator
  ) {
  }

  async ngOnInit() {
    this.summaryLoading = true;
    this.gridLoading = true;
    this.navHelperService.updateDailyLogRequiresReload(true);
    this.concurrentChanges.initialize(this);

    if (this.isModal) {
      this.ionViewEnter();
    }

    this.navHelperService.currentSidebarCollapsed.subscribe(sidebarCollapsed => {
      this.sidebarCollapsed = sidebarCollapsed;
    });

    // debounce used when confirming/un-confirming times in the log
    this.$confirmedChange
      .pipe(
        catchError(err => {
          this.debounceActive = false;
          throw (err.error);
        }),
        debounce(() => timer(1500)))
      .subscribe(val => {
        if (this.concurrentChanges.externalChangePending) {
          this.debounceActive = false;
          this.dataToUpdate = new AppData();
          return;
        }

        val.dailyLogDate = this.dailyLogDate.dateTime;

        this.appDataSyncService.quickSaveTimeConfirmation(val).then(() => {
          this.validate();
          this.debounceActive = false;
        });

        this.dataToUpdate = new AppData();
      });
  }

  ngOnDestroy(): void {
    this.concurrentChanges.destroy();
  }

  async ionViewEnter() {
    await this.concurrentChanges.start();

    if (this.inputDate) {
      await this.setDate(this.inputDate, true);
      this.inputDate = null; // need to null it as viewEnter may get recalled later and we dont want to re-run the above
    }

    // check if daily log requires reload, this exists so we don't need to reload the log every time the user returns from the validation
    // errors modal (because it's really annoying) - but any time the ngOnInit runs it will reload fully.
    // if the user takes an action in the ErrorsPage page, then this flag will get set to true
    this.navHelperService.dailyLogRequiresReload.subscribe(requiresReload => {
      this.dailyLogRequiresReload = requiresReload;
    });

    // setup configured
    this.navHelperService.currentSetupConfigured.subscribe(setupComplete => {
      this.setupComplete = setupComplete;
    });

    const lastPage = this.navCtrl.last().component.name;

    if (this.dailyLogRequiresReload || (lastPage !== 'ErrorsPage' && lastPage !== 'DailyProgressReportPreviewPage')) {
      this.loaded = false;
      this.gridLoading = true;

      const date = await this.dailyLogService.getCurrentLogDay();

      if (date != null) {
        this.dailyLogDate = cloneDeep(date);
        this.currentDate = cloneDeep(date);
        this.currentLogDate = cloneDeep(date.dateTime);
        this.maxDate = cloneDeep(date.dateTime); // temporarily set this so that it always has a value (this gets updated later)
      }

      await Promise.all([
        this.permissionService.dailyLogPermissions(),
        this.permissionService.lockedDayPermissions(this.dailyLogDate)
      ]).then(res => {
        this.permissions = res[0];
        this.lockedDayPermissions = res[1];
      });

      this.state = this.dailyLogService.getState();
      await this.updateSetupSummary();

      if (!this.dailyLogDate.dateTime) {
        this.gridLoading = false;
        return;
      }

      this.setDisplayDate();

      await Promise.all([
        this.updateDataEntryVariables(),
        this.checkDailyLogMovement(),
        this.loadGrid()
      ]);
    }

    this.dailyLogRequiresReload = false;
    this.navHelperService.updateDailyLogRequiresReload(false);
    this.initialLoadComplete = true;
  }

  ionViewLeave(): void {
    this.concurrentChanges.stop();
  }

  async updateSetupSummary() {
    this.summaryLoading = true;

    const summary = await this.setupService.getSetupSummary(this.dailyLogDate, true);

    await this.setupService.saveSetup(summary);
    const setupNeeded = summary?.phaseId == null ||
      summary?.projectId == null ||
      summary?.stageId == null;

    this.setupComplete = !setupNeeded;

    this.navHelperService.updateSetupConfigured(this.setupComplete);
    this.setupSummary = summary;
    this.summaryLoading = false;
  }

  async loadGrid() {
    if (!this.dailyLogDate.dateTime) {
      return;
    }

    if (!this.setupComplete) {
      // Pre-setup dates use the existing inactive-date screen, not operation loading/validation.
      this.dailyLogData = [];
      this.gridData = { data: [], total: 0 };
      this.loaded = true;
      this.gridLoading = false;
      this.validationLoading = false;
      this.pageLoading = false;
      return;
    }

    this.pageLoading = true;

    // IMPORTANT - this needs to run before getting timezones below, or timezones could be null (i.e on first app load after clearing local storage)
    // update daily log data and ensure result is awaited
    await this.appDataSyncService.updateDailyLogDataForDate({date: this.dailyLogDate.dateTime}, true);

    // Start non-essential loading in parallel, but wait for it before validation so that DPR validation uses refreshed data.
    const nonEssentialDataUpdate = this.appDataSyncService.updateNonDailyLogDataForDate({
      date: this.dailyLogDate.dateTime,
      loadLegLoadLogData: false,
      loadWeatherLogData: false
    });

    const data = await this.dailyLogService.getDailyLogDataForDay(this.dailyLogDate);
    this.dailyLogData = await this.dailyLogEntriesService.getRecordsIncludingContinuingOperations(data);

    if (data.nextDayData) { // if data has nextDayData, grid is loaded below
      const helper = await this.dailyLogEntriesService.createDateChangeRecord(0, data.endOfDay, null, 99999);
      this.dailyLogData.push(helper.records[0]);
    }

    await this.updateGrid();
    this.loaded = true;
    this.validationLoading = true;

    await nonEssentialDataUpdate;
    await this.validate();
  }

  async updateGrid() {
    this.dailyLogData = await this.dailyLogService.setReadingSortTimes(this.dailyLogData);
    this.gridData = this.dailyLogService.sortDailyLogRecords(this.dailyLogData, this.state);

    // customSort saved for every row, this is what enables the row swap functionality to work
    if (!this.dayCompleted) {
      // no need to save this again if day is complete, as nothing should have changed
      this.dailyLogService.assignCustomSortValues(this.gridData.data);
    }

    this.gridLoading = false;
    this.recordSaveLoading = false;

    let disableFlag = false;

    const allOperations = await this.operationService.getAllProjectSpecificOperationInstances(null);
    for (const log of this.gridData.data) {
      log.disabled = disableFlag;
      log.canConfirmTimes = await this.dailyLogTimeService.canConfirmTimes(log, allOperations);
      if (log.type === DailyLogType.DateChange || log.typeId === 16) {
        disableFlag = true;
      }
    }
  }

  async validate() {
    this.validationLoading = true;
    this.activeSnapshotSummary = null;

    if (this.dailyLogDate.dateTime) {
      const result = await this.validationService.validateDailyLog(this.dailyLogData, this.dailyLogDate);
      if (this.config.isImplementerEnvironment || !this.dayCompleted) {
        // update completeDay with info from validation, this is later used in implementer navigator page when colour coding date cells
        await this.completeDayService.updateCompleteDayValidationMetadata(result, cloneDeep(this.dailyLogDate));
      }

      this.validationResult = result;

      // normally when validation is valid, user can complete day - exception to this is when implementer is active and user is on
      // vessel non-implementer environment then they can't
      if (this.config.isVesselEnvironment && !this.config.isImplementerEnvironment && this.setupComplete) {
        this.activeSnapshotSummary = await this.implementerService.getActiveSnapshotSummary(this.config.isVesselEnvironment);
        this.activeImplementerPreventingDayCompletion = !!this.activeSnapshotSummary;
      }

      this.validationLoading = false;
      this.pageLoading = false;
    } else {
      this.validationLoading = false;
      this.pageLoading = false;
    }
  }

  async openErrorModal() {
    const operationIds = this.dailyLogData
      .filter(p => p.operationInstanceId || p.operationInstanceLocalId)
      .map(p => p.operationInstanceId ? p.operationInstanceId : p.operationInstanceLocalId)
      .filter((id, index, array) => array.indexOf(id) === index);

    const instances = await this.operationService
      .getProjectSpecificOperationInstances(operationIds);

    this.navCtrl.push(ErrorsPage,
      {
        date: this.dailyLogDate,
        validationResult: this.validationResult,
        overlapTimes: this.dailyLogValidatorService.findOverlapTimes(instances, this.dailyLogDate),
        dayCompleted: this.dayCompleted,
        // if implementer, then ensure that imp is active to show buttons, and that day is not complete
        showActionButtons: !this.dayCompleted
          && (!this.config.isImplementerEnvironment || (this.config.isImplementerEnvironment && this.isImplementerActiveForDay))
          && this.lockedDayPermissions.functionalPermissions.canEditOperationTimes
          && !this.concurrentChanges.externalChangePending,
        instances: instances,
        completeDay: false,
        refresh: true
      });
  }

  async saveDailyLogData(data: DailyOperationLogRecord[], dailyLogDataOnly?: boolean) {
    await this.dailyLogService.saveDailyLogData(data);

    if (!dailyLogDataOnly) {
      await this.recordOperationLinkService.updateOperations(data);
    }
  }

  async checkDailyLogMovement() {
    const timeZone = await this.timeZoneService.getEditorLocally({
      dateTime: this.dailyLogDate.dateTime,
      dateAmbiguous: false
    });
    this.maxDate = await this.completeDayService.getLatestDate() as DateTime;
    this.activeLogDate = this.maxDate;

    if (!this.config.isImplementerEnvironment) {
      this.canGoForward = this.maxDate > this.dailyLogDate.dateTime;
      return;
    }

    if (timeZone) {
      this.canGoForward = this.dayCompleted || this.maxDate > this.dailyLogDate.dateTime;
    } else {
      this.canGoForward = true;
    }
  }

  // if the user changes system clock to go backwards, (i.e GMT +1 to UTC 0), then when the user clicks on the datepicker to change dates
  // the max date will be set to the current log date -1 day, so this will be called when the user hovers over the datepicker to update these values
  async updateDailyLogDate() {
    this.dailyLogDate = await this.dailyLogService.getCurrentLogDay();

    if (this.dailyLogDate != null) {
      this.dailyLogDate = cloneDeep(this.dailyLogDate);
      this.currentDate = cloneDeep(this.dailyLogDate);
      this.currentLogDate = cloneDeep(this.dailyLogDate.dateTime);

      if (this.maxDate < this.dailyLogDate.dateTime) {
        this.maxDate = cloneDeep(this.dailyLogDate.dateTime);
      }
    }
  }

  async setDate(value: DateTime, fromInputDate?: boolean) {
    if (!this.config.isImplementerEnvironment && value > await this.completeDayService.getLatestDate()) {
      return;
    }
    if (this.changingLogDate) {
      return;
    }
    this.retainLogDuringDateChange = !fromInputDate && !!this.gridData && this.initialLoadComplete && this.setupComplete;
    this.changingLogDate = !fromInputDate;
    this.dateChangeError = null;
    try {
      this.concurrentChanges.resetForDateChange();
      this.activeImplementerPreventingDayCompletion = null; // null this here so relevant info is immediately removed from the DOM and doesn't show for a split second
      this.initialLoadComplete = false;
      this.dateChangeLoading = true;
      this.dateLoading = true;
      this.summaryLoading = true;

      // Keep the rendered rows and validation summary until their replacements arrive.
      // The retained view is inert throughout the date change.
      this.gridLoading = true;
      this.setupComplete = true;

      this.dailyLogDate.dateTime = value;

      const tz = await this.timeZoneService.getEditorLocally({dateTime: value});

      if (tz) {
        this.dailyLogDate.setOffset(tz.secondsOffsetFromUtc);
      } else {
        this.dailyLogDate.setOffset(0);
      }

      this.currentLogDate = this.dailyLogDate.dateTime; // used for the datepicker in the daily log datepicker
      this.dailyLogService.setCurrentLogDay(this.dailyLogDate.dateTime);

      // only need to run below when user changes using daily log datepicker, if from input then those will run in viewEnter
      if (!fromInputDate) {
        await this.updateSetupSummary();
        await this.reloadPageAfterDayChange();
      }
    } catch (error) {
      this.initialLoadComplete = false;
      this.dateChangeError = 'Unable to load this day. Select a date to try again.';
      this.dateLoading = false;
      this.dateChangeLoading = false;
      this.pageLoading = false;
      throw error;
    } finally {
      this.changingLogDate = false;
      this.retainLogDuringDateChange = false;
    }
  }

  async decreaseDate() {
    // if user has changed machine timezone, then we need to update this or the wrong daily log date will get saved, and wrong data will show
    this.dailyLogDate = await this.dailyLogService.getCurrentLogDay();

    // any offset changes between the two dates are applied in setDate()
    const newLocalDate = this.dailyLogDate.dateTime.minus({day: 1});
    await this.setDate(newLocalDate, false);
  }

  async increaseDate() {
    // if user has changed machine timezone, then we need to update this or the wrong daily log date will get saved, and wrong data will show
    this.dailyLogDate = await this.dailyLogService.getCurrentLogDay();

    // any offset changes between the two dates are applied in setDate()
    const newLocalDate = this.dailyLogDate.dateTime.plus({day: 1});
    await this.setDate(newLocalDate, false);
  }

  async reloadPageAfterDayChange(dailyLogDate?: PtLuxonDate) {
    this.gridLoading = true;
    if (!this.retainLogDuringDateChange) {
      this.loaded = false;
    }

    this.dailyLogDate = await this.dailyLogService.getCurrentLogDay();

    this.setDisplayDate();

    await Promise.all([
      this.updateDataEntryVariables(),
      this.loadGrid(),
      this.checkDailyLogMovement(),
    ]);

    // if there's no local date here it means that the user has gone back to a date before logging started
    // set the local date as the date generated in increase/decrease date methods so that the log date at least loads
    if (!this.dailyLogDate.dateTime && dailyLogDate) {
      this.dailyLogDate.dateTime = dailyLogDate.dateTime;
    }

    this.initialLoadComplete = true;
  }

  reloadDailyLogAfterExternalChange(): Promise<void> {
    return this.reloadPageAfterDayChange();
  }

  async viewRecord(row: DailyOperationLogRecord) {
    if (this.changingLogDate || this.isReadonly || this.concurrentChanges.externalChangePending) {
      return;
    }

    const record = await this.dailyLogService.getDailyOperationLogRecord(row.id || row.localId);

    if (record != null) {
      if (!!record.operationInstanceId || !!record.operationInstanceLocalId) {
        const operation = await this.operationService.getProjectSpecificOperationInstance(
          record.operationInstanceId
            ? record.operationInstanceId
            : record.operationInstanceLocalId);

        await this.navCtrl.push(OperationDetailsEditPage, {instance: operation}, {animation: 'ios-transition'});
      } else if (record.typeId === DailyLogType.Comment) {

        this.navCtrl.push(CommentEditPage, {
          record: record,
          lockedDayPermissions: this.lockedDayPermissions
        });
      }
    } else if (row.operationInstanceId) {
      const operation = await this.operationService.getProjectSpecificOperationInstance(row.operationInstanceId
        ? row.operationInstanceId
        : row.operationInstanceLocalId);

      await this.navCtrl.push(OperationDetailsEditPage, {instance: operation}, {animation: 'ios-transition'});
    }
  }

  public async cellClickHandler(event: any) {
    if (this.changingLogDate || !this.permissions.canManageDailyLog || this.concurrentChanges.externalChangePending) {
      return;
    }

    if (event.dataItem && event.dataItem.selectedSwapHighlight) {
      // if user is in swap rows mode
      await this.reorderRows(event);
    } else if (event.dataItem && event.column && event.column.field === 'startTimeConfirmed' && !this.isModal) {
      // if user has clicked in the start confirmed cell

      if (!this.dayLockedByDate || (this.config.isImplementerEnvironment && !this.isImplementerActiveForDay)) {
        return;
      }

      const recordIndex = this.gridData.data.findIndex(e => event.dataItem.id
        ? e.id === event.dataItem.id
        : e.localId === event.dataItem.localId);
      if (this.showStartConfirmCheckbox(event.dataItem) && event.dataItem.canConfirmTimes && this.gridData.data[recordIndex].startTimeConfirmed != null) {
        await this.startTimeConfirmedChanged(event.dataItem);
      }
    } else if (event.dataItem && event.column && event.column.field === 'endTimeConfirmed' && !this.isModal) {
      // if user has clicked in the end confirmed cell

      if (!this.dayLockedByDate || (this.config.isImplementerEnvironment && !this.isImplementerActiveForDay)) {
        return;
      }

      const recordIndex = this.gridData.data.findIndex(e => event.dataItem.id
        ? e.id === event.dataItem.id
        : e.localId === event.dataItem.localId);
      if (this.showEndConfirmCheckbox(event.dataItem) && event.dataItem.canConfirmTimes && this.gridData.data[recordIndex].startTimeConfirmed != null) {
        await this.endTimeConfirmedChanged(event.dataItem);
      }
    } else if (event.column.field !== 'actions'
      && event.column.field !== 'startTimeShow'
      && event.column.field !== 'endTimeShow'
      && !event.disabled) {
      // if user has clicked a row to highlight related rows
      this.highlightCommonRows(event);
    }
  }

  async startTimeChanged(row: DailyOperationLogRecord) {
    if (this.changingLogDate) {
      return;
    }

    if (this.concurrentChanges.externalChangePending) {
      this.recordSaveLoading = false;
      return;
    }

    this.recordSaveLoading = true;
    const index = this.dailyLogData.findIndex(e => row.id ? e.id === row.id : e.localId === row.localId);

    if (await this.timeEnteredInvalid(row.startTimeShow, row, index, true)) {
      return;
    }

    const newTime = await this.dateService.setPtLuxonDateFromUserEnteredString(row.startTimeShow, this.dailyLogDate.dateTime);
    this.dailyLogTimeService.lastTimeConfirmedFlag = row.startTimeConfirmed;
    this.dailyLogTimeService.timeConfirmedMouseUpFlag = !row.startTimeConfirmed;

    // check if user is trying to remove time
    if (!this.canRemoveStartTime(row.type as any) && row.startTimeShow === '') {
      this.resetRegex();
      row.startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      this.recordSaveLoading = false;
      return;
    }

    if (await this.timeUnchanged(row.startTimeShow, row, row.startTime, true)) {
      return;
    }

    if (await this.dateClashesWithTimeZoneChange(newTime, row, index, true)) {
      return;
    }

    if (await this.dateHasMultiplePossibleOffsets(newTime, row, index, true)) {
      return;
    }

    if (await this.setupChangeTimeEdited(row, index)) {
      return;
    }

    if (await this.commentTimeEdited(row, index)) {
      return;
    }

    if (await this.operationStartAfterOperationEnd(newTime, row)) {
      return;
    }

    if (await this.dateBeforeOperationStart(newTime, row, true)) {
      return;
    }

    if (await this.timeZoneChangeTimeEdited(row)) {
      return;
    }

    if (await this.stepStartEndEqual(newTime, row, index, true)) {
      return;
    }

    if (await this.checkOrphanedComments(row, newTime, index, true)) {
      return;
    }

    if (await this.commentStartAfterEnd(row, newTime, index)) {
      return;
    }

    // logic here for handling updating future step times
    if (index != null && index !== -1) {
      const dailyLogEditHelper = await this.dailyLogTimeService.startTimeChanged(this.dailyLogData, row.id ? row.id : row.localId, this.dailyLogDate);

      this.dailyLogData = dailyLogEditHelper.dailyLogData;

      if (dailyLogEditHelper.preventDataChange) {
        this.showDateChangeWarning(row.startTimeShow, 'future step invalid');
        this.resetRegex();
        this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
        await this.updateGrid();
        this.recordSaveLoading = false;
        return;
      }

      await this.updateGrid();
    } else {
      this.dailyLogTimeService.mouseUpWait(row, true, this);
    }

    const rowType = row.type as any;
    if (rowType === DailyLogType.OperationStart
      || rowType === 'operationStart'
      || rowType === DailyLogType.OperationEnd
      || rowType === 'operationEnd'
      || rowType === DailyLogType.Step
      || rowType === 'step') {
      this.updateConcurrency(row);
    }

    this.validate();
  }

  async endTimeChanged(row: DailyOperationLogRecord) {
    if (this.changingLogDate) {
      return;
    }

    if (this.concurrentChanges.externalChangePending) {
      this.recordSaveLoading = false;
      return;
    }

    this.recordSaveLoading = true;
    const timeClone = cloneDeep(row.endTime);
    const index = this.dailyLogData.findIndex(e => row.id ? e.id === row.id : e.localId === row.localId);

    if (await this.timeEnteredInvalid(row.endTimeShow, row, index, false)) {
      return;
    }

    const newTime = await this.dateService.setPtLuxonDateFromUserEnteredString(row.endTimeShow, this.dailyLogDate.dateTime);
    this.dailyLogTimeService.timeConfirmedMouseUpFlag = !row.endTimeConfirmed;

    // if endTime was previously nulled, e.g by a delay, then offset will be 0, so need to update it
    row.endTimeOffset = newTime.dateTime.offset / 60;

    if (await this.dateClashesWithTimeZoneChange(newTime, row, index, false)) {
      return;
    }

    if (await this.dateHasMultiplePossibleOffsets(newTime, row, index, false)) {
      return;
    }

    if (await this.timeUnchanged(row.endTimeShow, row, row.endTime, false)) {
      return;
    }

    if (await this.stepEndBeforeStepStart(newTime, row, index)) {
      return;
    }

    if (await this.stepStartEndEqual(newTime, row, index, false)) {
      return;
    }

    if (await this.dateBeforeOperationStart(newTime, row, false)) {
      return;
    }

    if (await this.checkOrphanedComments(row, newTime, index, false)) {
      return;
    }

    // logic here for handling updating future step times
    if (index != null && index !== -1) {
      const dailyLogEditHelper = await this.dailyLogTimeService.endTimeChanged(this.dailyLogData, row.id ? row.id : row.localId, this.dailyLogDate);

      this.dailyLogData = dailyLogEditHelper.dailyLogData;

      if (dailyLogEditHelper.preventDataChange) {
        this.resetRegex();
        this.showDateChangeWarning(row.endTimeShow, 'future step invalid');
        this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(timeClone);
        await this.updateGrid();
        this.recordSaveLoading = false;
        return;
      }

      await this.updateGrid();
    } else {
      this.dailyLogTimeService.mouseUpWait(row, false, this, true);
    }

    const rowType = row.type as any;
    if (rowType === DailyLogType.OperationStart
      || rowType === 'operationStart'
      || rowType === DailyLogType.OperationEnd
      || rowType === 'operationEnd'
      || rowType === DailyLogType.Step
      || rowType === 'step') {
      this.updateConcurrency(row);
    }

    this.validate();
  }

  // check if entered date coincides with a timezone change
  private async dateClashesWithTimeZoneChange(newDate: PtLuxonDate, row: DailyOperationLogRecord, index: number, startChanged: boolean): Promise<boolean> {
    const lostInTimeResult = cloneDeep(newDate.isLostInTime);

    if (lostInTimeResult && lostInTimeResult.result) {
      if (startChanged) {
        await this.showLostInTimeWarning(row.startTimeShow, lostInTimeResult.timeZone);
        this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      } else {
        await this.showLostInTimeWarning(row.endTimeShow, lostInTimeResult.timeZone);
        this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
      }

      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  // check if time is in multiple possible timezones - i.e coincides with a negative timezone change
  private async dateHasMultiplePossibleOffsets(newDate: PtLuxonDate, row: DailyOperationLogRecord, index: number, startChanged: boolean): Promise<boolean> {
    if (newDate.multipleOffsets && newDate.multipleOffsets.result) {
      if (startChanged) {
        await this.showMultipleTimezoneWarning(row.startTimeShow);
        this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      } else {
        // check if time is in multiple possible timezones - i.e coincides with a negative timezone change
        if (newDate.multipleOffsets && newDate.multipleOffsets.result) {
          await this.showMultipleTimezoneWarning(row.endTimeShow);
          this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
        }
      }

      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  private async timeEnteredInvalid(timeShow: string, row: DailyOperationLogRecord, index: number, startChanged: boolean): Promise<boolean> {
    if (!this.dateService.timeIsValid(timeShow, true)) {
      if (startChanged) {
        this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      } else {
        this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
      }

      this.resetRegex();
      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  // if time hasn't been changed (user just clicked in then out)
  private async timeUnchanged(newTimeShow: string, row: DailyOperationLogRecord, ptDate: PtLuxonDate, startChanged: boolean): Promise<boolean> {
    if (newTimeShow === this.dateService.setTimeStringFromPtLuxonDate(ptDate)) {
      if (startChanged) {
        await this.startTimeConfirmedChanged(row);
      } else {
        await this.endTimeConfirmedChanged(row);
      }

      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  private async dateBeforeOperationStart(newTime: PtLuxonDate, row: DailyOperationLogRecord, startChanged: boolean): Promise<boolean> {
    if (newTime && newTime.dateTime && newTime.dateTime.toMillis() < row.operationStartTime.dateTime.toMillis()
      && ((row.typeId as any) !== DailyLogType.OperationStart && (row.typeId as any) !== 2)) {
      if (startChanged) {
        await this.showDateChangeWarning(row.startTimeShow, 'end');
        row.startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      } else {
        await this.showDateChangeWarning(row.endTimeShow, 'end');
        row.endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
      }

      this.resetRegex();
      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  // if step end is now equal to step start
  private async stepStartEndEqual(newTime: PtLuxonDate, row: DailyOperationLogRecord, index: number, startChanged: boolean): Promise<boolean> {
    if (row.typeId === DailyLogType.Step
      && row.stepInstance && row.stepInstance.step
      && row.stepInstance.step.defaultSecondsSpan !== 0
      && row.endTimeConfirmed
      && newTime.dateTime
      && row.endTime.dateTime
      && newTime.dateTime.toMillis() === row.endTime.dateTime.toMillis()) {

      if (startChanged) {
        await this.showDateChangeWarning(row.startTimeShow, 'equal');
        this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      } else {
        await this.showDateChangeWarning(row.endTimeShow, 'equal');
        this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
      }

      this.resetRegex();
      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  // if step end is before step start, or operation end is before previous time, show warning and revert change
  private async stepEndBeforeStepStart(newTime: PtLuxonDate, row: DailyOperationLogRecord, index: number): Promise<boolean> {
    if ((newTime && newTime.dateTime && row.startTime.dateTime && newTime.dateTime < row.startTime.dateTime)
      || (newTime.dateTime && (!row.startTime || !row.startTime.dateTime))) {
      if ((row.typeId as any) === 'operationEnd' || (row.typeId as any) === DailyLogType.OperationEnd) {
        const operationInstance = await this.operationService.getProjectSpecificOperationInstance(
          row.operationInstanceId
            ? row.operationInstanceId
            : row.operationInstanceLocalId);
        let lastTime = operationInstance.startTime;

        if (operationInstance && operationInstance.stepCollectionInstance &&
          operationInstance.stepCollectionInstance.stepInstances && operationInstance.stepCollectionInstance.stepInstances.length > 0) {
          const filteredStepCollection = operationInstance.stepCollectionInstance.stepInstances.filter(e => !e.exclude);
          lastTime = filteredStepCollection[operationInstance.stepCollectionInstance.stepInstances.length - 1].endTime;
        }

        if (newTime.dateTime < lastTime.dateTime) {
          await this.showDateChangeWarning(row.endTimeShow, 'operation end');
          this.resetRegex();
          this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
          this.recordSaveLoading = false;
          return true;
        }
      } else {
        await this.showDateChangeWarning(row.endTimeShow, 'end');
        this.resetRegex();
        this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
        this.recordSaveLoading = false;
        return true;
      }
    }

    return false;
  }

  private async operationStartAfterOperationEnd(newTime: PtLuxonDate, row: DailyOperationLogRecord): Promise<boolean> {
    if (newTime && newTime.dateTime && row.operationEndTime && row.operationEndTime.dateTime && newTime.dateTime.toMillis() > row.operationEndTime.dateTime.toMillis()
      && ((row.typeId as any) === DailyLogType.OperationStart || (row.typeId as any) === 2)) {
      const operationInstance = await this.operationService.getOperationInstance(row.operationInstanceId);

      // we only care if the op start is bigger than the end, if the end is confirmed, becayse ff it's not confirmed then the end will get
      // adjusted to be later than the newTime anyway.
      if (operationInstance && operationInstance.endConfirmed) {
        await this.showDateChangeWarning(row.startTimeShow, 'operation end');
        row.startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);

        this.resetRegex();
        this.recordSaveLoading = false;
        return true;
      }
    }

    return false;
  }

  // stop user from entering a time that would result in a comment falling outside operation times
  private async checkOrphanedComments(row: DailyOperationLogRecord, newDate: PtLuxonDate, index: number, startTimeChanged: boolean): Promise<boolean> {
    const operationInstance = await this.operationService.getProjectSpecificOperationInstance(row.operationInstanceId);

    if (!operationInstance || !operationInstance.comments || operationInstance.comments.length === 0) {
      return false;
    }

    // resolve dates set false above so we can correct the comment dates in here without potentially effecting other areas
    operationInstance.comments.forEach(comment => {
      if (comment.startTimeDate) {
        comment.startTimeDate = PtLuxonDate.assignPtLuxonDate(comment.startTimeDate);
      }
    });

    if (startTimeChanged && operationInstance.comments.some(c => c.startTimeDate.dateTime < newDate.dateTime)) {
      await this.showDateChangeWarning(row.startTimeShow, 'comment-orphan');
      this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      this.resetRegex();
      this.recordSaveLoading = false;
      return true;
    } else if (!startTimeChanged && operationInstance.comments.some(c => c.startTimeDate.dateTime > newDate.dateTime)) {
      await this.showDateChangeWarning(row.endTimeShow, 'comment-orphan');
      this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
      this.resetRegex();
      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  private async commentStartAfterEnd(row: DailyOperationLogRecord, newDate: PtLuxonDate, index: number): Promise<boolean> {
    if ((row.type as any) === DailyLogType.Comment && row.startTimeShow !== '' && newDate.dateTime > row.endTime.dateTime) {
      this.resetRegex();
      this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  // if setup change, need to update setup change log records + any batched changes
  private async setupChangeTimeEdited(row: DailyOperationLogRecord, index: number): Promise<boolean> {
    if (this.dailyLogTimeService.isSetupChange(row.typeId)) {
      await this.updateSetupRecord(row, index);
      await this.updateSetupSummary();
      await this.loadGrid();
      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  private async commentTimeEdited(row: DailyOperationLogRecord, index: number): Promise<boolean> {
    if (row.typeId === DailyLogType.Comment) {
      await this.updateDailyLogComment(cloneDeep(row), index, true);
      this.dailyLogData[index] = row;
      this.resetRegex();
      this.recordSaveLoading = false;
      await this.updateGrid();
      return true;
    }

    return false;
  }

  private async timeZoneChangeTimeEdited(row: DailyOperationLogRecord): Promise<boolean> {
    if (((row.type as any) === DailyLogType.TimeZone || row.typeId === 18) && !!row.startTime) {
      row.startTime = await this.dateService.setPtLuxonDateFromUserEnteredString(row.startTimeShow, row.startTime.dateTime);
      row.sortTime = cloneDeep(row.startTime.dateTime) as DateTime;
      const timeZoneEditor = await this.timeZoneService.getEditorByIdLocally(row.timeZoneId);
      timeZoneEditor.dateTime = row.startTime.dateTime;
      timeZoneEditor.timeOfChange = row.startTime.dateTime;
      await this.timeZoneService
        .saveEditor(timeZoneEditor)
        .then();

      const instances = await this.operationService.getAllProjectSpecificOperationInstances(null);

      const appData = new AppData();
      appData.dailyLogOperationInstances = instances;
      appData.dailyLogRecords = this.dailyLogData;
      appData.cleanseLogs = false;
      await this.appDataService.saveAppData(appData);

      await this.updateGrid();
      this.recordSaveLoading = false;
      return true;
    }

    return false;
  }

  async goToActiveLogDay() {
    const date = this.activeLogDate || this.maxDate;
    if (this.activeDayNavigationLoading || this.changingLogDate || !date?.isValid
      || date.toMillis() === this.dailyLogDate?.dateTime.toMillis()) { return; }
    this.activeDayNavigationLoading = true;
    try { await this.setDate(date); }
    finally { this.activeDayNavigationLoading = false; }
  }

  // if user enters a time for an operation that is before the operation start time, show warning explaining this isn't allowed.
  async showDateChangeWarning(newRecordTime: string, type: string) {
    const title = 'Warning';
    const cssClass = 'daily-log-modal-four-line';
    let message = '';
    let optionalMessage = 'Only times within the same day may be entered in the Daily Log. In order to change a time to the ' +
      'following day the operation edit screen must be used instead.';

    switch (type) {
      case 'start': {
        message = `The entered time of \'${newRecordTime}\' is invalid, as this would result in the start time occurring before the
        operation start time.`;
        break;
      }
      case 'end': {
        message = `The entered time of \'${newRecordTime}\' is invalid, as this would result in the end time occurring before the
        record start time.`;
        break;
      }
      case 'operation end': {
        message = `The entered time of \'${newRecordTime}\' is invalid, as this would result in a step or operation start occurring after
        the operation has ended.`;
        break;
      }
      case 'future step invalid': {
        message = `The entered time of \'${newRecordTime}\' is invalid, as this would result in a step being pushed onto the next day.`;
        break;
      }
      case 'equal': {
        message = `The entered time of \'${newRecordTime}\' is invalid, as this would result in the step having no duration.`;
        optionalMessage = `This step has been assigned a duration by the Operations team, and is therefore not allowed to have
          a duration of 0 minutes.`;
        break;
      }
      case 'comment-orphan': {
        message = `The entered time of \'${newRecordTime}\' is invalid, as this would result in a comment falling outside of operation times.`;
        optionalMessage = `Comment time must be edited first to prevent this from occurring.`;
        break;
      }
      case 'comment-invalid': {
        message = `The entered time of \'${newRecordTime}\' is invalid, as this would result in the comment falling outside of operation times.`;
        optionalMessage = `Comments not linked to an operation can be added via the 'Add to Daily Log' item in the Menu.`;
        break;
      }
    }

    const warningModal = this.modalController.create(WarningModalComponent, {
      title: title,
      message: message,
      optionalMessage: optionalMessage,
    }, {cssClass: cssClass});

    warningModal.present();
  }

  async showLostInTimeWarning(newRecordTime: string, timeZoneChangeEditor: TimeZoneChangeEditor) {
    const title = 'Warning';
    const cssClass = 'daily-log-modal-two-line';
    const message = `The entered time of \'${newRecordTime}\' isn't allowed due to a time zone change
    from \'${timeZoneChangeEditor.timeOfChangeToShow}\' to \'${timeZoneChangeEditor.dateToShow}\' `;

    const warningModal = this.modalController.create(WarningModalComponent, {
      title: title,
      message: message,
    }, {cssClass: cssClass});

    warningModal.present();
  }

  async showMultipleTimezoneWarning(newRecordTime: string) {
    const title = 'Warning';
    const cssClass = 'daily-log-modal-three-line';
    const message = `The entered time of \'${newRecordTime}\' coincides with a negative Timezone change.`;
    const optionalMessage = `This time must be changed using the Operation Edit page to ensure that the correct time offset is selected.`;

    const warningModal = this.modalController.create(WarningModalComponent, {
      title: title,
      message: message,
      optionalMessage: optionalMessage,
    }, {cssClass: cssClass});

    warningModal.present();
  }


  async updateConcurrency(row: DailyOperationLogRecord) {
    await this.dailyLogTimeService.updateOperationConcurrency(this.dailyLogData, row.operationInstanceId);
    this.updateGrid();
  }

  canEnterTimes(row: DailyOperationLogRecord, field: string): boolean {
    switch (row.lineTypeName) {
      case 'Operation Start':
      case 'Project Change':
      case 'Phase Change':
      case 'Stage Change':
      case 'Location Change':
      case 'Vessel Master Change':
      case 'Client Rep Change':
      case 'Client Rep Title Change':
      case 'Other Rep Change':
      case 'Other Rep Title Change':
      case 'Concurrent Start':
      case 'Contractual Start':
      case 'Cancelled':
      case 'Transiting To':
      case 'Operation Paused':
      case 'Operation Resumed':
      case 'Continued':
      case 'Continued Step':
      case 'Comment':
      case 'Cycle Change':
        if (field === 'startTimeShow') {
          return true;
        }
        break;
      case 'Operation End':
      case 'Concurrent End':
      case 'Contractual End':
        if (field === 'endTimeShow') {
          return true;
        }
        break;
      case 'Step':
        return true;
      case 'Time Zone Change':
        if (field === 'endTimeShow' && !!row.endTime && !!row.endTime.dateTime) {
          return true;
        }

        if (field === 'startTimeShow' && !!row.startTime && !!row.startTime.dateTime) {
          return true;
        }

        return false;
    }

    return false;
  }

  canRemoveStartTime(type: DailyLogType) {
    if (type === DailyLogType.OperationStart
      || type === DailyLogType.Step
      || type === DailyLogType.Comment
      || type === DailyLogType.LocationChange
      || type === DailyLogType.StageChange
      || type === DailyLogType.PhaseChange
      || type === DailyLogType.VesselMasterChanged
      || type === DailyLogType.ProjectChange) {
      return false;
    }

    return true;
  }

  async checkTimeIsValid(timeToShow: string): Promise<boolean> {
    if ((await this.dateService.setPtLuxonDateFromUserEnteredString(timeToShow, this.dailyLogDate.dateTime)).dateTime !== null) {
      return true;
    }
    return false;
  }

  highlightCommonRows(event: any) {
    if (event.dataItem.selected === true) {
      this.gridData.data.forEach(e => {
        e.selected = false;
      });
    } else {
      if (this.gridData.data.some(e => e.selected === true)) {
        this.gridData.data.forEach(e => {
          e.selected = false;
        });
      }
      if (event
        && event.dataItem
        && (event.dataItem.operationInstanceId || event.dataItem.operationInstanceLocalId)
        && !event.selectedSwap
        && !event.selectedSwapHighlight) {
        const operationId = event.dataItem.operationInstanceId
          ? event.dataItem.operationInstanceId
          : event.dataItem.operationInstanceLocalId;
        const selectedRows = this.gridData.data
          .filter(e => e.operationInstanceId ? e.operationInstanceId === operationId : e.operationInstanceLocalId === operationId);

        selectedRows.forEach(e => {
          const index = this.gridData.data.findIndex(f => (e.id && f.id === e.id) || (e.localId != null && f.localId === e.localId));
          if (index !== -1) {
            this.gridData.data[index].selected = true;
          }
        });
      }
    }
  }

  highlightSwappableRows(event: DailyOperationLogRecord) {
    if (event && event.selectedSwap === true) {
      this.removeAllGridHighlights();
    } else if (event) {
      const recordSortTime = event.sortTime;
      const selectedSwapRows = (this.gridData.data as DailyOperationLogRecord[]).filter(e => {
        // removing milliseconds from the comparison
        return Math.floor(e.sortTime.toMillis() / 1000) === Math.floor(recordSortTime.toMillis() / 1000) && e.id !== event.id;
      });

      // highlight selected row
      const selectedIndex = this.gridData.data.findIndex(e => e.id === event.id);
      this.gridData.data[selectedIndex].selectedSwap = true;

      // highlight swappable rows
      this.gridData.data.forEach(e => {
        if (selectedSwapRows.some(s => s.id === e.id && e.typeId !== 12 && e.typeId !== 13)) {
          e.selectedSwapHighlight = true;
        } else if (e.id !== event.id) {
          e.disabled = true;
        }
      });
    }
  }

  async openDeleteConfirmationModel(row: DailyOperationLogRecord) {
    this.gridLoading = true;
    const title = 'Confirm Removal';
    let typeText = '';
    let itemText = '';
    let optionalText = '';
    let validation: ValidationResult = new ValidationResult();
    let validationLoading = false;
    let cssClass = 'daily-log-modal-one-line';
    let preventLocationChangeRecordDeletion = false;
    let showKeepCommentsCheckbox = false;

    switch (row.typeId) {
      case 2:
        typeText = 'Operation';
        itemText = row.operationName;
        optionalText = 'Removing the Operation will also permanently remove any Steps, Comments, and Forms associated with it.';
        let gaps = new ValidationResult;

        if (row.isContractual) {
          gaps = await this.findContractualGaps(row);
        }

        if (gaps.errors.length > 0) {
          validation = gaps;
          cssClass = 'daily-log-modal-with-validation';
        } else {
          cssClass = 'daily-log-modal-three-line';
        }

        if (row.operationInstanceId && await this.operationService.operationIsLinkedToVoyageLogStart(row.operationInstanceId)) {
          const validationError = new ValidationError();
          validationError.type = ErrorType.Warning;
          validationError.message = 'Removing this Operation will result in its linked voyage log being removed';
          cssClass = 'daily-log-modal-with-validation';
          validation.errors.push(validationError);
        }

        if (row.operationInstanceId && await this.operationService.operationIsLinkedToVoyageLogEnd(row.operationInstanceId)) {
          const validationError = new ValidationError();
          validationError.type = ErrorType.Warning;
          validationError.message = 'Removing this Operation will result in the linked voyage log end date, location, and distance being removed';
          cssClass = 'daily-log-modal-with-validation';
          validation.errors.push(validationError);
        }

        if (row.operationClassification === 'Rig Move') {
          const locationChangeRecord = await this.dailyLogService
            .getDailyLogRecord(row.operationInstanceId, null, DailyLogType.LocationChange, row.operationInstanceLocalId);
          validationLoading = true;
          if (locationChangeRecord != null) {
            this.setupService.canDeleteSetupChange(locationChangeRecord.id)
              .subscribe(result => {
                if (result.errors.length > 0 || result.warnings.length > 0) {
                  if (result.errors.length > 0) {
                    preventLocationChangeRecordDeletion = true;
                    const validationError = new ValidationError();
                    validationError.type = ErrorType.Warning;
                    validationError.message = 'Removing this Operation will not remove the linked Location change record as ' +
                      'this would result in no Location existing.';
                    validation.errors.push(validationError);
                    validationLoading = false;
                  }
                }

                confirmationModal.present();
              });
          } else {
            validationLoading = false;
          }
        }

        if (await this.operationService.checkOperationInstanceHasComments(row.operationInstanceId)) {
          showKeepCommentsCheckbox = true;
          cssClass = cssClass + "-with-checkbox";
        }
        break;
      case 8:
        typeText = 'Comment';
        itemText = row.comment != null ? row.comment.data : null;
        break;
      case 4:
        typeText = 'Location Change';
        optionalText = 'This will also remove any setup changes that were made at the same time as this Stage change.';
        cssClass = 'daily-log-modal-three-line';
        break;
      case 5:
        typeText = 'Stage Change';
        optionalText = 'This will also remove any setup changes that were made at the same time as this Stage change.';
        cssClass = 'daily-log-modal-three-line';
        break;
      case 6:
        typeText = 'Phase Change';
        optionalText = 'This will also remove any setup changes that were made at the same time as this Phase change.';
        cssClass = 'daily-log-modal-three-line';
        break;
      case 7:
        typeText = 'Project Change';
        optionalText = 'This will also remove any setup changes that were made at the same time as this Project change.';
        cssClass = 'daily-log-modal-three-line';
        break;
      case 9:
        typeText = 'Vessel Master Change';
        optionalText = 'This will also remove any setup changes that were made at the same time as this Project change.';
        cssClass = 'daily-log-modal-three-line';
        break;
      case 19:
        typeText = 'Setup Change';
        optionalText = 'This will also remove any setup changes that were made at the same time as this change.';
        cssClass = 'daily-log-modal-three-line';
        break;
      case 18:
        typeText = 'Time Zone Change';
        if (this.config.isImplementerEnvironment) {
          optionalText = 'This will update all future dates in the app, including days which have not been locked for ' +
            'editing in implementer mode. It is advisable to double check future dates are correct and re-generate any affected reports.';
          cssClass = 'daily-log-modal-four-line';
        }
        break;
      case 20:
        typeText = 'Cycle Change';
        itemText = row.operationName;
        optionalText = 'This will undo the cycle change.';
        cssClass = 'daily-log-modal-three-line';
        break;
    }

    const confirmationModal = this.modalController.create(ConfirmationModalComponent, {
      title: title,
      item: itemText,
      message: 'Are you sure you want to permanently remove this ' + typeText + '?',
      optionalMessage: optionalText,
      validation: validation,
      trueText: 'Confirm',
      falseText: 'Cancel',
      typeId: row.typeId,
      itemId: row.id,
      showButtons: true,
      showKeepCommentsCheckbox: showKeepCommentsCheckbox
    }, {cssClass: cssClass});

    const deletionData = new AppDataSummary();
    this.gridLoading = false;

    confirmationModal.onDidDismiss(async data => {
      if (data && data.choice) {
        this.gridLoading = true;
        switch (row.typeId) {
          case 2: // op start
            if (!preventLocationChangeRecordDeletion) {
              // remove location change if there is one linked with this op - this needs to come before removing the daily log records
              const logData = await this.dailyLogService.getLogsForOperation(row.operationInstanceId ? row.operationInstanceId : row.operationInstanceLocalId);
              let locationChangeRecord = logData.find(e => e.typeId === 4);

              if (locationChangeRecord) {
                // move location change to previous operation in transit
                const updatedLocationChangeRecord = await this.transitingSaveService.tryRevertLocationChangeEntry(locationChangeRecord);

                if (updatedLocationChangeRecord) {
                  const index = this.dailyLogData.findIndex(e => e.id === locationChangeRecord.id);
                  // update here will also update dailyLogData, so it won't get deleted below
                  this.dailyLogData[index] = updatedLocationChangeRecord.dailyLogRecords[0];
                  updatedLocationChangeRecord.dailyLogDate = cloneDeep(this.dailyLogDate.dateTime);
                  await this.appDataSyncService.saveAppData(updatedLocationChangeRecord);
                } else {
                  const setupRecord = await this.getSetupLocationChangeRecord(locationChangeRecord.id
                    ? locationChangeRecord.id
                    : locationChangeRecord.localId);

                  if (setupRecord) {
                    deletionData.setupChangeLogRecordIds.push(setupRecord.id ? setupRecord.id : setupRecord.localId);
                  }
                }
              } else {
                // if no location change record, check if op is a rig move, and if it is a rig move, and also has no end time, then we want
                // to check for a previous operation in the transit, and make sure if it has an archived location change, we un-archive it
                const updatedLocationChangeRecordHelper = await this.transitingSaveService.tryUnarchivePreviousLocationChangeRecord(row);

                if (updatedLocationChangeRecordHelper.dailyLogRecords && updatedLocationChangeRecordHelper.dailyLogRecords.length > 0) {
                  updatedLocationChangeRecordHelper.dailyLogDate = cloneDeep(this.dailyLogDate.dateTime);
                  await this.appDataSyncService.saveAppData(updatedLocationChangeRecordHelper);
                }
              }
            }

            // remove operation
            deletionData.dailyLogOperationInstanceIds
              .push(row.operationInstanceId ? row.operationInstanceId : row.operationInstanceLocalId);
            this.operationService
              .deleteProjectSpecificOperation(row.operationInstanceId ? row.operationInstanceId : row.operationInstanceLocalId);

            // remove daily log records
            const recordsToRemove = this.dailyLogData.filter(e => row.operationInstanceId
              ? e.operationInstanceId === row.operationInstanceId
              : e.operationInstanceLocalId === row.operationInstanceLocalId);

            if (preventLocationChangeRecordDeletion) {
              const index = recordsToRemove.findIndex(e => e.typeId === 4);
              recordsToRemove.splice(index, 1);
            }

            recordsToRemove.forEach(record => {
              deletionData.dailyLogRecordIds.push(record.id ? record.id : record.localId);
            });

            deletionData.keepComments = data.keepComments;

            await this.appDataSyncService.deleteAppData(deletionData);

            this.summaryLoading = true;

            this.setupService
              .getSetupSummary(this.dailyLogDate, true)
              .then(summary => {
                this.setupSummary = summary;
                this.summaryLoading = false;
              });
            break;
          case 8: // comment
            deletionData.dailyLogRecordIds.push(row.id ? row.id : row.localId);

            const appData = new AppData();
            const instance = await this.operationService
              .getOperationInstance(row.operationInstanceId ? row.operationInstanceId : row.operationInstanceLocalId);

            if (instance) {
              const index = instance.comments.findIndex(e => row.comment.recordApiId
                ? e.recordApiId === row.comment.recordApiId
                : e.recordApiId === row.comment.recordLocalId);

              if (index !== -1) {
                instance.comments.splice(index, 1);
              }

              appData.dailyLogOperationInstances = [instance];
            }

            appData.dailyLogDate = cloneDeep(this.dailyLogDate.dateTime);

            await this.appDataSyncService.syncLocalData(appData, true);
            await this.appDataSyncService.deleteAppData(deletionData);

            break;
          case 4: // location change
          case 5: // stage change
          case 6: // phase change
          case 7: // project change
          case 9: // vessel master change
          case 19: // other setup change
            deletionData.dailyLogRecordIds.push(row.id ? row.id : row.localId);
            deletionData.setupChangeLogRecordIds.push(row.setupChangeLogApiId ? row.setupChangeLogApiId : row.localSetupChangeLogRecordId);

            await this.appDataSyncService.deleteAppData(deletionData);

            this.updateSetupSummary();
            break;
          case 18: // time zone change
            deletionData.dailyLogRecordIds.push(row.id ? row.id : row.localId);
            deletionData.timeZoneChangeId = row.timeZoneId;

            await this.appDataSyncService.deleteAppData(deletionData);
            await this.timeZoneService.deleteLocalTimeZone(row.timeZoneId);
            break;
          case 20: // cycle change
            await this.cyclesService.deleteChange(row.id, this.dailyLogDate.dateTime);
            await this.updateSetupSummary();
            break;
          default:
            break;
        }

        this.loadGrid();
      }
    });

    if (!validationLoading) {
      confirmationModal.present();
    }
  }

  async getSetupLocationChangeRecord(dailyLogLocationChangeRecordId: number) {
    const setupData = await this.setupService.getSetupChangeLogData();
    return setupData
      .find(e => e.dailyLogRecordId
        ? e.dailyLogRecordId === dailyLogLocationChangeRecordId
        : e.localDailyLogRecordId === dailyLogLocationChangeRecordId);
  }

  /* Used to check there will be no contractual gaps if the user removes an operation */
  async findContractualGaps(record: DailyOperationLogRecord): Promise<ValidationResult> {
    const validationResult: ValidationResult = new ValidationResult();

    const overlaps = await this.operationService
      .getProjectSpecificOperationInstance(record.operationInstanceId ? record.operationInstanceId : record.operationInstanceLocalId)
      .then(async instance => {
        return this.contractualOperationValidatorService.checkPartialDelayOverlap(instance);
      });

    const overLapOperations: DailyLogOperationInstance[] = [];
    for (let i = 0; i < overlaps.length; i++) {
      const overlap = await this.operationService.getProjectSpecificOperationInstance(overlaps[i].operationInstanceId);
      overLapOperations.push(overlap);
    }

    const gaps = await this.dailyLogValidatorService.findGapsInOperations(overLapOperations);

    if (!gaps) {
      return validationResult;
    }

    if (gaps.length > 0) {
      validationResult.addError(`Removing this Operation will create a gap in the days' contractual operations `, ErrorType.Warning);
    }

    return validationResult;
  }

  // gets called for every row to selectively apply different css styles
  public assignRowSelected(context: RowClassArgs) {
    return {
      'selected': context.dataItem.selected === true,
      'selected-swap': context.dataItem.selectedSwap === true,
      'selected-swap-highlight': context.dataItem.selectedSwapHighlight === true,
      'greyed-selected': context.dataItem.disabled && context.dataItem.selected,
      'greyed': context.dataItem.disabled && !context.dataItem.selected
    };
  }

  async reorderRows(event: any) {
    const selectedRowIndex = this.dailyLogData.findIndex(e => e.selectedSwap === true);
    const destinationRowIndex = this.dailyLogData.findIndex(e => e.id === event.dataItem.id);

    const tempOrdinal = event.dataItem.ordinal;
    const tempUniqueOrdinal = event.dataItem.uniqueOrdinal;
    const tempSortTime = event.dataItem.sortTime;
    const tempCustomSort = event.dataItem.customSort;

    // anything that is used in the state variable that is used to determine grid sorting, needs to be swapped between the two rows
    this.dailyLogData[destinationRowIndex].ordinal = this.dailyLogData[selectedRowIndex].ordinal;
    this.dailyLogData[destinationRowIndex].uniqueOrdinal = this.dailyLogData[selectedRowIndex].uniqueOrdinal;
    this.dailyLogData[destinationRowIndex].sortTime = this.dailyLogData[selectedRowIndex].sortTime;
    this.dailyLogData[destinationRowIndex].customSort = this.dailyLogData[selectedRowIndex].customSort;

    this.dailyLogData[selectedRowIndex].ordinal = tempOrdinal;
    this.dailyLogData[selectedRowIndex].uniqueOrdinal = tempUniqueOrdinal;
    this.dailyLogData[selectedRowIndex].sortTime = tempSortTime;
    this.dailyLogData[selectedRowIndex].customSort = tempCustomSort;

    this.removeAllGridHighlights();

    const selectedRow = cloneDeep(this.dailyLogData[selectedRowIndex]);
    const destinationRow = cloneDeep(this.dailyLogData[destinationRowIndex]);

    const appDataBlob = new AppData();
    appDataBlob.dailyLogRecords = [selectedRow, destinationRow];

    // save daily log records locally, before the api save - so we don't have to wait
    await this.saveDailyLogData([this.dailyLogData[selectedRowIndex], this.dailyLogData[destinationRowIndex]], true);

    appDataBlob.dailyLogDate = cloneDeep(this.dailyLogDate.dateTime);

    await this.appDataSyncService.saveAppData(appDataBlob);

    this.updateGrid();
  }

  allowedToChangeStepNumbers(
    selectedRecord: DailyOperationLogRecord,
    destinationRecord: DailyOperationLogRecord,
    selectedOperation: DailyLogOperationInstance,
    destinationOperation: DailyLogOperationInstance): boolean {
    if (selectedRecord.stepNumber != null && destinationRecord.stepNumber != null) {
      return true;
    }

    if (selectedOperation && destinationOperation &&
      (selectedOperation.id !== destinationOperation.id)) {
      return false;
    }

    return false;
  }

  async startTimeConfirmedChanged(row: DailyOperationLogRecord) {
    if (this.changingLogDate) {
      return;
    }

    if (row.canConfirmTimes) {
      row.startTimeConfirmed = !row.startTimeConfirmed;

      if (row.stepInstance) {
        row.stepInstance.startConfirmed = row.startTimeConfirmed;
      }

      let rowCopy = cloneDeep(row);

      this.sendToDebounce(rowCopy);
    }
  }

  async endTimeConfirmedChanged(row: DailyOperationLogRecord) {
    if (this.changingLogDate) {
      return;
    }

    if (row.canConfirmTimes) {
      row.endTimeConfirmed = !row.endTimeConfirmed;

      if (row.stepInstance) {
        row.stepInstance.endConfirmed = row.endTimeConfirmed;
      }

      let rowCopy = cloneDeep(row);

      this.sendToDebounce(rowCopy);
    }
  }

  async sendToDebounce(row: DailyOperationLogRecord) {
    this.dataToUpdate.dailyLogRecords = this.dataToUpdate.dailyLogRecords.filter(p => p.id !== row.id);
    this.dataToUpdate.dailyLogRecords.push(row);

    if (!!row.operationInstanceId) {
      const instance = await this.operationService.getProjectSpecificOperationInstance(row.operationInstanceId);

      if (!!instance) {
        this.dataToUpdate.dailyLogOperationInstances = this.dataToUpdate.dailyLogOperationInstances
          .filter(p => p.id !== instance.id);

        this.dataToUpdate.dailyLogOperationInstances.push(instance);
      }
    }

    this.$confirmedChange.next(this.dataToUpdate);
    this.debounceActive = true;
  }

  removeAllGridHighlights() {
    this.gridData.data.forEach(e => {
      e.selectedSwapHighlight = false;
      e.selectedSwap = false;
      e.disabled = false;
    });
  }

  regexChange(inputTime: string) {
    if (inputTime.charAt(0) === '2') {
      this.mask[1] = new RegExp('[0-3]');
    } else {
      this.mask[1] = new RegExp('\\d');
    }
  }

  resetRegex() {
    this.mask = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  }

  preventTimeInputBlur(event: any) {
    event.preventDefault();
  }

  checkDateExists(date: PtLuxonDate): boolean {
    if (!date.dateTime) {
      return false;
    }

    return true;
  }

  mouseUp() {
    this.dailyLogTimeService.timeConfirmedMouseUpFlag = true;
  }

  openDailyProgressReportPreview() {
    const date = new PtLuxonDate(this.dailyLogDate.dateTime);
    const reportContext: DailyProgressReportContext = this.setupSummary && !this.summaryLoading ? {
      dateMillis: date.dateTime.toMillis(),
      summary: {
        updatedSetupSummary: cloneDeep(this.setupSummary),
        vesselName: this.setupSummary.vesselName,
        clientName: this.setupSummary.projectClientName
      }
    } : null;
    this.navCtrl.push(DailyProgressReportPreviewPage, { date, reportContext });
  }

  async completeDay() {
    if (this.concurrentChanges.externalChangePending) {
      return;
    }

    const instances = await this.operationService.getOperationsFromLogs(this.dailyLogData);

    await this.navCtrl.push(DailyProgressReportPreviewPage,
      {
        validationResult: this.validationResult,
        overlapTimes: this.dailyLogValidatorService.findOverlapTimes(instances, this.dailyLogDate),
        instances: instances,
        showActionButtons: !this.dayCompleted && (!this.config.isImplementerEnvironment || this.config.isImplementerEnvironment && this.isImplementerActiveForDay),
        completeDay: true,
        date: this.dailyLogDate,
      });
  }

  openSignatureModal() {
    if (this.concurrentChanges.externalChangePending) {
      return;
    }

    const signatureModal = this.modalController.create(SignatureDateModalComponent, { isSignOff: true, dailyLogDate: this.dailyLogDate }, { cssClass: 'fullscreen-modal' });

    signatureModal.onDidDismiss(data => {
      if (data && data.confirmed && !this.concurrentChanges.externalChangePending) {
        this.signOffDay(data.signatureDate, data.clientComments, data.signatures);
      }
    });

    signatureModal.present();
  }

  async signOffDay(signatureDate?: DateTime, clientComments?: string, signatures?: SignaturesPayload) {
  if (this.concurrentChanges.externalChangePending) {
    return;
  }

  this.signOffDayLoading = true;
  this.vesselService.getEditor().then(async vesselEditor => {
    const response = await this.dprService
      .signOffDpr(
        this.dailyLogDate,
        vesselEditor.id,
        this.config.isImplementerEnvironment,
        signatureDate,
        clientComments,
        signatures
      )
      .toPromise();

    this.daySignedOff = true;
    this.signOffDayLoading = false;

    if (response.report.size > 0) {
      const downloadUrl = window.URL.createObjectURL(response.report);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = response.filename;
      a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      a.remove();
    }
  });
  }

  signOffDayOld(signatureDate?: DateTime, clientComments?: string) {
    this.vesselService.getEditor().then(vesselEditor => {
      const downloadLink = this.dprService.getSignOffDprLink(this.dailyLogDate, vesselEditor.id, this.config.isImplementerEnvironment, signatureDate);

      setTimeout(() => {
        location.href = downloadLink;
        this.daySignedOff = true;
      });
    });
  }

  // one method for all - that checks dayCompleted, implementer status, etc, and sets canEnterData flag
  async updateDataEntryVariables() {
    await Promise.all([
      this.checkImplementerActive(),
      this.checkDayCompleted(),
      this.checkDayLocked(),
    ]);

    await this.setCanEnterDataFlag();
    this.updateSupportContext();
  }

  async setCanEnterDataFlag() {
    if (!this.dayCompleted
      && ((this.config.isImplementerEnvironment && this.isImplementerActiveForDay) || (!this.config.isImplementerEnvironment && this.dayLockedByDate))) {
      this.navHelperService.updateCanEnterData(true);
    } else {
      this.navHelperService.updateCanEnterData(false);
    }
  }

  // isImplementerEnvironment variable only tells us if the environment is the implementer, we still need to check if current date falls between
  // snapshotSummary start and end dates, if it does then we know this date is editable
  async checkImplementerActive() {
    // implementer cannot be active if day has not been completed (unless user is in implementer environment)
    this.isImplementerActiveForDay = (this.config.isImplementerEnvironment || this.dayCompleted)
      ? await this.implementerService.implementerIsActive(this.config.isVesselEnvironment, cloneDeep(this.dailyLogDate))
      : false;
  }

  async checkDayLocked() {
    if (!this.dailyLogDate.dateTime) {
      return;
    }

    const filters = new LockDayFilters();
    filters.date = cloneDeep(this.dailyLogDate.dateTime);
    let lockedSummary = await this.lockedDayService.checkDay(filters);

    this.dayLockedByDate = lockedSummary.lockedByDate;
    this.lockable = lockedSummary.lockable;

    if (!this.config.isImplementerEnvironment) {
      const workflow = await this.completeDayService.getWorkflow(this.dailyLogDate);
      this.canEditRecentDay = workflow.canEdit;
    }

    const timeZoneFilters = new TimeZoneFilters();
    timeZoneFilters.dateTime = lockedSummary.latestDate;
  }

  async checkDayCompleted() {
    if (!this.dailyLogDate.dateTime) {
      return;
    }

    const filters: CompleteDayFilters = {
      date: this.dailyLogDate.dateTime
    };

    this.dayCompleted = await this.completeDayService.checkDay(filters);

    await this.checkDaySignOff();
  }

  async checkDaySignOff() {
    if (!this.dailyLogDate.dateTime) {
      return;
    }

    // no need to call API here if day is not completed, because it's impossible to sign a day off if its not complete
    this.daySignedOff = this.dayCompleted ? await this.dailyProgressReportService.hasSignedOffDpr(this.dailyLogDate) : false;
  }

  openImplementerInitialiser() {
    if (this.concurrentChanges.externalChangePending) {
      return;
    }

    this.supportContextService.setComponentContext(SupportContextKey.ImplementerMode, 'Implementer Mode', 'ImplementerInitialiserPage');
    this.navCtrl.push(ImplementerInitialiserPage, {
      dailyLogDate: this.dailyLogDate,
      lockedDayPermissions: this.lockedDayPermissions
    });
  }

  async removeCompleteDay() {
    if (this.concurrentChanges.externalChangePending) {
      return;
    }

    this.editDayLoading = true;
    const completeDayEditor = await this.completeDayService.setDayNotComplete(this.dailyLogDate);

    if (completeDayEditor) {
      this.dayCompleted = completeDayEditor.isComplete;
      this.daySignedOff = completeDayEditor.isSignedOff;

      await this.navHelperService.updateCanEnterData(!completeDayEditor.isComplete);
      this.updateSupportContext();
    }

    this.editDayLoading = false;
  }

  async editRecentDay() {
    if (this.editDayLoading || this.concurrentChanges.externalChangePending || !this.permissions.canAmendPreviousDay
      || this.config.isImplementerEnvironment) {
      return;
    }
    this.editDayLoading = true;
    this.dayWorkflowError = null;
    try {
      await this.completeDayService.editRecentDay(this.dailyLogDate);
      await this.updateDataEntryVariables();
    } catch (error) {
      this.dayWorkflowError = 'Unable to edit this day. Refresh and check that it is still the current or previous day.';
    } finally {
      this.editDayLoading = false;
    }
  }

  otherPagesNotComplete(): boolean {
    if (this.validationResult.errors.some(e => e.pageValidationType != null
      && e.pageValidationType !== PageValidationType.DailyObservations
      && e.pageValidationType !== PageValidationType.FieldPositioning
      && e.pageValidationType !== PageValidationType.RobFuelFigures
      && e.pageValidationType !== PageValidationType.OnSiteMovement
      && e.pageValidationType !== PageValidationType.VoyageLog)) {
      return true;
    }

    return false;
  }

  private async updateDailyLogComment(row: DailyOperationLogRecord, index: number, startTimeChanged: boolean) {
    if (row.operationInstanceId) {
      const operationEndTime = row.operationEndTime && row.operationEndTime.dateTime
         ? cloneDeep(row.operationEndTime) as PtLuxonDate
         : null as PtLuxonDate;

      const fallsWithinOperationalTimes = this.dateService.timeFallsWithin(
        startTimeChanged
          ? (await this.dateService.setPtLuxonDateFromUserEnteredString(row.startTimeShow, this.dailyLogDate.dateTime)).dateTime
          : (await this.dateService.setPtLuxonDateFromUserEnteredString(row.endTimeShow, this.dailyLogDate.dateTime)).dateTime,
        row.operationStartTime.dateTime,
        operationEndTime.dateTime);
      if (!fallsWithinOperationalTimes) {
        if (startTimeChanged) {
          this.dailyLogData[index].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
          await this.showDateChangeWarning(row.startTimeShow, 'comment-invalid');
        } else {
          this.dailyLogData[index].endTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.endTime);
          await this.showDateChangeWarning(row.endTimeShow, 'comment-invalid');
        }

        return row;
      }
    }

    const startTime = await this.dateService.setPtLuxonDateFromUserEnteredString(row.startTimeShow, row.startTime.dateTime);

    this.dailyLogData[index].sortTime = startTime.dateTime;

    this.dailyLogData[index].startTime = startTime;
    this.dailyLogData[index].operationStartTime = row.operationStartTime;
    this.dailyLogData[index].comment.startTimeDate = startTime;
    this.dailyLogData[index].comment.startTimeToShow = this.dailyLogData[index].startTimeShow;

    const instance = await this.operationService.getProjectSpecificOperationInstance(this.dailyLogData[index].operationInstanceId);
    const appData = new AppData();

    if (instance) {
      const commentIndex = instance.comments.findIndex(e => e.id === row.comment.id);

      if (commentIndex !== -1) {
        instance.comments[commentIndex].startTimeDate = startTime;
        instance.comments[commentIndex].startTimeToShow = row.startTimeShow;

        appData.dailyLogOperationInstances = [instance];
      }
    }

    appData.dailyLogRecords = [this.dailyLogData[index]];

    const appDataClone = cloneDeep(appData);
    const savedData = await this.appDataService.saveAppData(appDataClone);
    await this.appDataSyncService.refreshDailyLogRelatedLocalData(savedData, null, true);
  }

  private setDisplayDate() {
    // todo - add the n-th to this formatted string, i.e 1'st', 3'rd'. 5'th', will need to manually do this or use moment as luxon cant do it
    this.dailyLogDisplayDate = this.dailyLogDate.dateTime.toFormat('EEEE, dd MMMM y');
    this.dateLoading = false;
    this.dateChangeLoading = false;
  }

  async updateSetupRecord(row: DailyOperationLogRecord, rowIndex: number) {
    this.gridLoading = true;
    const setupRecord = await this.setupService.getSetupChangeLogRecord(row.setupChangeLogApiId
      ? row.setupChangeLogApiId
      : row.localSetupChangeLogRecordId);

    if (setupRecord.previousValue == null && this.setupChangeTypeNotOther(setupRecord.changeTypeId)) {
      this.dailyLogData[rowIndex].startTimeShow = this.dateService.setTimeStringFromPtLuxonDate(row.startTime);
      const warningModal = this.modalController.create(WarningModalComponent, {
        title: 'Warning',
        message: 'This Setup Change cannot be altered, as it is one of the original setup changes entered into the system.',
        optionalMessage: null,
      }, {cssClass: 'daily-log-modal-two-line'});

      warningModal.present();
      this.gridLoading = false;
      return;
    }

    const batchedRecords = await this.setupService.getSetupChangeLogDataBatchRecords(setupRecord.id
      ? setupRecord.id
      : setupRecord.localId, setupRecord.batchId);

    const appDataBlob = new AppData();
    const newTime = await this.dateService.setPtLuxonDateFromUserEnteredString(row.startTimeShow, this.dailyLogDate.dateTime);

    setupRecord.timeOfChangeToShow = row.startTimeShow;
    setupRecord.timeOfChange = newTime;

    row.startTime = newTime;
    row.sortTime = newTime.dateTime;
    row.operationStartTime = newTime;

    appDataBlob.dailyLogRecords.push(row);
    appDataBlob.setupChangeLogRecords.push(setupRecord);

    for (const batchedRecord of batchedRecords) {
      const batchRecordDailyLogRecord = await this.dailyLogService.getDailyLogRecordDirect(batchedRecord.dailyLogRecordId
        ? batchedRecord.dailyLogRecordId
        : batchedRecord.localDailyLogRecordId);

      batchedRecord.timeOfChange = newTime;
      batchedRecord.timeOfChangeToShow = row.startTimeShow;

      batchRecordDailyLogRecord.startTimeShow = row.startTimeShow;
      batchRecordDailyLogRecord.startTime = newTime;
      batchRecordDailyLogRecord.sortTime = newTime.dateTime;
      batchRecordDailyLogRecord.operationStartTime = newTime;

      appDataBlob.dailyLogRecords.push(batchRecordDailyLogRecord);
      appDataBlob.setupChangeLogRecords.push(batchedRecord);
    }

    await this.appDataSyncService.syncLocalData(appDataBlob, false, true);
  }

  showStartConfirmCheckbox(row: DailyOperationLogRecord) {
    if (!row) {
      return false;
    }

    return row.startTime != null
      && row.startTimeShow != null
      && (row.lineTypeName === 'Step'
        || row.lineTypeName === 'Operation Start'
        || row.lineTypeName === 'Operation End');
  }

  showEndConfirmCheckbox(row: DailyOperationLogRecord) {
    if (!row) {
      return false;
    }

    return (row.endTime != null
      && row.endTimeShow != null
      && (row.lineTypeName === 'Step'
        || row.lineTypeName === 'Operation Start'
        || row.lineTypeName === 'Operation End'))
      && (row.endTimeShow !== row.startTimeShow)
      || (this.canEnterTimes(row, 'endTimeConfirmed')
        && (row.stepInstance && row.stepInstance.step && row.stepInstance.step.defaultSecondsSpan !== 0) && row.startTimeShow === row.endTimeShow);
  }

  viewChangeHistory() {
    this.navCtrl.push(ChangeHistoryPage, {
      startDailyLogDate: this.dailyLogDate,
      endDailyLogDate: this.dailyLogDate,
      creationTimeFilterDate: null,
      snapshotSummaryId: null
    });
  }

  private updateSupportContext() {
    if (this.isModal) {
      return;
    }

    const additionalSuggestedContextKeys = this.dayCompleted && !this.config.isImplementerEnvironment && !!this.lockable
      ? [SupportContextKey.ImplementerMode]
      : undefined;

    this.supportContextService.setComponentContext(
      SupportContextKey.DailyLog,
      'Daily Log',
      'DailyLogPage',
      undefined,
      additionalSuggestedContextKeys
    );
  }

  private setupChangeTypeNotOther(changeTypeId: SetupChangeType) {
    return changeTypeId !== SetupChangeType.OtherRepChange
      && changeTypeId !== SetupChangeType.OtherRepTitleChange
      && changeTypeId !== SetupChangeType.ClientRepChange
      && changeTypeId !== SetupChangeType.ClientRepTitleChange;
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log-component/daily-log-component.component.ts